import { Link } from "react-router-dom";
import { useContent } from "@/content";
import { Lockup } from "@/components/Brand";

export const Footer = () => {
  const c = useContent();
  if (!c.nav) return null;
  const f = c.ui.footer;
  return (
    <footer className="grain border-t border-copper/25 bg-night pb-28 pt-20 text-white md:pb-12" data-testid="site-footer">
      <div className="mx-auto max-w-[1320px] px-6 md:px-12">
        <div className="grid gap-14 md:grid-cols-[1.2fr_2fr]">
          <div>
            <Lockup />
            <p className="mt-6 font-serif text-xl italic text-white/85">{c.hero.tagline}</p>
          </div>
          <nav aria-label="Pied de page" className="grid grid-cols-2 gap-x-8 gap-y-3 text-sm text-white/75 md:grid-cols-3">
            {[...c.nav.items, c.nav.cta].map((it) => (
              <Link key={it.label} to={it.to || `/#${it.hash}`} data-testid={`footer-${(it.hash || it.to).replace(/\//g, "")}`} className="link-line w-fit py-1 transition-colors hover:text-white">{it.label}</Link>
            ))}
            <Link to="/contact" data-testid="footer-contact" className="link-line w-fit py-1 hover:text-white">{c.ui.contactTeam}</Link>
          </nav>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-copper/20 pt-8 text-[0.75rem] uppercase tracking-[0.22em] text-white/85 md:flex-row md:items-center md:justify-between">
          <span>© {f.rights}</span>
          <span data-testid="footer-credit">
            {f.credit}{" "}
            <a href={f.agencyUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-credit-link" className="text-copper underline-offset-4 hover:underline">{f.agency}</a>
          </span>
        </div>
      </div>
    </footer>
  );
};
